import saveAs from 'file-saver';
import iconv from 'iconv-lite';

// Leading characters that make Excel/LibreOffice evaluate a cell as a
// formula (CWE-1236). Purely numeric values (e.g. a -5.2 reading) must
// stay untouched, so the prefix is only added when the cell is not a number.
const FORMULA_TRIGGER_RE = /^[=+\-@\t\r]/;

export const toCsvValue = (value) => {
  let cell = value === null || value === undefined ? '' : String(value);

  if (FORMULA_TRIGGER_RE.test(cell) && !Number.isFinite(Number(cell))) {
    cell = `'${cell}`;
  }

  if (/[",\r\n]/.test(cell)) {
    cell = `"${cell.replace(/"/g, '""')}"`;
  }

  return cell;
};

export const parseJsonToCsv = (jsonData, showLabel = true) => {
  // If jsonData is not an object then JSON.parse will parse the JSON string in an Object
  const arrData =
    typeof jsonData !== 'object' ? JSON.parse(jsonData) : jsonData;

  let csvStr = '';

  // This condition will generate the Label/Header
  if (showLabel) {
    let row = '';

    // This loop will extract the label from 1st index of on array
    for (const index in arrData[0]) {
      // Now convert each value to string and comma-seprated
      row += index + ',';
    }

    row = row.slice(0, -1);

    // append Label row with line break
    csvStr += row + '\r\n';
  }

  // 1st loop is to extract each row
  for (let i = 0; i < arrData.length; i++) {
    let nwRow = '';

    // 2nd loop will extract each column and convert it in string comma-seprated
    for (const indexNew in arrData[i]) {
      nwRow += '"' + arrData[i][indexNew] + '",';
    }

    nwRow.slice(0, nwRow.length - 1);

    // add a line break after each Row
    csvStr += nwRow + '\r\n';
  }

  return csvStr;
};

export const saveCsvFile = (csvData, givenFileNme) => {
  // Generate a file name
  let fileName = '';
  // this will remove the blank-spaces from the title and replace it with an underscore
  fileName += givenFileNme.replace(/ /g, '_');

  // Initialize file format you want csv or xls
  const BOM = '\uFEFF';
  const csvContent = BOM + csvData; // here we load our csv data
  const blob = new Blob([csvContent], {
    type: 'text/csv;charset=utf-8;encoding=utf-8;',
  });
  saveAs(blob, fileName);
};

export const saveCsvFileWithShiftJIS = (csvData, fileName) => {
  // Convert the CSV string to Shift-JIS encoding
  const encodedData = iconv.encode(csvData, 'Shift_JIS');

  // Create a Blob from the encoded data
  const blob = new Blob([encodedData], { type: 'text/csv;charset=shift-jis;' });

  // Use the FileSaver.js library to save the file
  saveAs(blob, fileName);
};
